import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { AssignmentForm } from '../forms/AssignmentForm';

type AssignmentModalProps = {
  isOpen: boolean;
  teachingUnitUuid?: string;
  assignmentUuid: string | null;
  onClose: () => void;
};

export const AssignmentModal = ({ isOpen, teachingUnitUuid, assignmentUuid, onClose }: AssignmentModalProps) => {
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal hideHeader isOpen={isOpen} loading={loading} onRequestClose={() => onClose()}>
      <AssignmentForm
        teachingUnitUuid={teachingUnitUuid}
        assignmentUuid={assignmentUuid}
        isModal
        onLoad={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
